import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

import { onDeleteAdminRes } from "./helper";

const deleteAdmin = async (id: number) =>
  axios.delete(Routes.DELETE_ADMIN + "/" + id);

export const useDeleteAdmin = () =>
  useMutation({
    mutationKey: [Keys.DELETE_ADMIN_MUT],
    mutationFn: deleteAdmin,
    onSuccess: onDeleteAdminRes,
  });
